<template>
  <v-container>
    <div id="headersMelhoresProdutores">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Produtor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Quantidade de leite(Litros)
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Preço médio
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in melhoresProdutores"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_produtor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.qtdleite }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.ultimoprecocota }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="mostrarTotalizador"
          class="tabela-totalizador"
        >
          <span>
            <strong>
              Total de leite:
              {{ quantidadeTotal }}
            </strong>
          </span>
        </div>
        <router-link
          to="/produtores/detalhe-melhores-entregasleite-produtores"
          :style="styleObject"
        >
          <div
            id="linkDetalheMelhoresProdutores"
            class="text-center"
          >
            <v-icon
              id="iconLinkMelhoresProdutores"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

  <script>
  import EntregaLeite from '../../../../services/entregaleite'
  import eventEmit from '../core/EventoEmit'

  export default {
    name: 'ProdutoresExibicaoMelhores',
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersMelhoresProdutores: [
        { text: 'Produtor', value: 'nome_produtor', class: 'black--text title' },
        { text: 'Quantidade de leite(Litros)', value: 'qtdleite', class: 'black--text title' },
        { text: 'Preço médio', value: 'ultimoprecocota', class: 'black--text title' },
      ],
      melhoresProdutores: [],
      vendedores: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      quantidadeTotal: 0,
    }),

    computed: {
      alturaTabela () {
        const rowHeight = 48
        const headerHeight = 48
        const maxRows = 7
        if (this.melhoresProdutores.length === 0) {
          return headerHeight + 'px'
        } else if (this.melhoresProdutores.length < maxRows) {
          return this.melhoresProdutores.length * rowHeight + headerHeight + 'px'
        } else {
          return '350px'
        }
      },
      mostrarTotalizador () {
        return this.melhoresProdutores.length > 0
      },
    },

    created () {
      eventEmit.$on('set_produtores_mais_entregaramleite', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_produtores_mais_entregaramleite', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, produtor, linhasleite) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.produtorSelect = produtor
        this.linhaSelect = linhasleite

        this.showMelhoresProdutores()
      },

      async showMelhoresProdutores () {
        this.loading = true
        this.melhoresProdutores = []

        await EntregaLeite.showMelhoresProdutores(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.melhoresProdutores = resposta.data.dadosMelhoresProdutores.map((item) => {
              var listaMelhoresProdutores = ({
                nome_produtor: item.nome_produtor,
                qtdleite: this.formateNum(item.qtdleite),
                quantidade: item.quantidade,
                ultimoprecocota: this.formatMoeda(item.precocota),
              })

              return listaMelhoresProdutores
            })
            this.quantidadeTotal = this.formateNum(resposta.data.quantidadeTotal)
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.melhoresProdutores = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
      },
      formatMoeda (num) {
        return 'R$' + num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })
      },
    },
  }
  </script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #textotabela {
    font-size: 0.75rem !important
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .tabela-totalizador {
    display: table;
    width: 100%;
    table-layout: fixed;
    color: black;
    border-collapse: collapse;
    border-top: 1px solid #ccc;
    font-family: inherit;
  }

  .tabela-totalizador span {
    display: table-cell;
    padding: 8px;
    vertical-align: middle;
    border-bottom: 1px solid #ddd;
    font-weight: normal;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersMelhoresProdutores {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersMelhoresProdutores {
      width: 100% !important;
    }
  }
  .totalizador td {
    font-weight: bold;
  }
</style>
